export const isFloat = (num: string) => {
  return parseFloat(num) % 1 !== 0;
};
